import { FC, ReactNode } from 'react';
import { FirstCategoryLevel } from 'src/api/types';
import NextImage from 'src/shared-components/NextImage/NextImage';
import cn from 'classnames';
import useMedia from 'src/hooks/useMedia';
import { generateFirstLevelCategoryPageLink } from 'src/utils/links';
import NavigationLink from '../NavigationLink/NavigationLink';

export const getIconSrc = (categoryName) => `categories/${categoryName}.svg`;

export const getIconProps = (
  categoryName
): { width: number; height: number } => {
  switch (categoryName) {
    case 'antibiotiki':
      return {
        height: 30,
        width: 30
      };
    case 'bad-i-vitaminy':
      return {
        height: 31,
        width: 32
      };
    case 'kosmetika-i-gigiyena':
      return {
        height: 31,
        width: 31
      };
    case 'medikamenty':
      return {
        height: 30,
        width: 31
      };
    case 'meditsinskiye-tovary':
      return {
        height: 30,
        width: 23
      };
    case 'optika':
      return {
        height: 31,
        width: 28
      };
    case 'seksualnoye-zdorovye':
      return {
        height: 31,
        width: 28
      };
    case 'tovary-dlya-kosmetologov':
      return {
        height: 30,
        width: 32
      };
    case 'tovary-dlya-mam-i-detey':
      return {
        height: 30,
        width: 31
      };
    default:
      return {
        height: 30,
        width: 30
      };
  }
};

type NavigationListItem = FirstCategoryLevel | null;

interface Props {
  listClassName: string;
  items: NavigationListItem[];
  selectedItem: NavigationListItem;
  setSelectedItem: (item: NavigationListItem) => void;
  children: ReactNode;
}

const NavigationList: FC<Props> = ({
  listClassName,
  items,
  selectedItem,
  setSelectedItem,
  children
}) => {
  const { m } = useMedia();
  const isMobileDevice = !m;
  const clickHandler = (item, ev) => {
    setSelectedItem(item);
    // Waiting for the selected item to open to get the current position of the selected item.
    setTimeout(() => ev.target.scrollIntoView(), 4);
  };
  return (
    <ul className={listClassName}>
      {items?.map((item) => {
        const selected = item.translitName === selectedItem?.translitName;
        return (
          <li key={item.translitName} className="h-[48px]">
            {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
            <div
              onMouseEnter={
                !isMobileDevice ? () => setSelectedItem(item) : null
              }
              onClick={isMobileDevice ? (ev) => clickHandler(item, ev) : null}
              className={cn(
                'flex relative border-b border-gray200 last:border-none items-center h-full',
                selected &&
                  'text-primary border-none pb-0 bg-white text-astronautBlue fs-body-bold'
              )}
            >
              <NavigationLink
                key={item?.translitName}
                href={generateFirstLevelCategoryPageLink({
                  category: item
                })}
              >
                <div
                  className={cn(
                    'w-full flex items-center justify-between compendium-w-full-105 h-full top-0 cursor-pointer'
                  )}
                >
                  <div className="flex items-center justify-center w-19 px-6">
                    <NextImage
                      alt="arrow"
                      src={getIconSrc(item.translitName)}
                      layout="fixed"
                      height={getIconProps(item.translitName).height}
                      width={getIconProps(item.translitName).width}
                    />
                  </div>
                  <p className="w-full text-black pr-6">{item.name}</p>
                </div>
              </NavigationLink>
            </div>
            {selected && children}
          </li>
        );
      })}
    </ul>
  );
};

export default NavigationList;
